import PropTypes from 'prop-types'
import classnames from 'classnames'
import ButtonLink, { buttonLinkType } from './buttons/ButtonLink'

import classes from './LockError.module.scss'
import { ReactComponent as LockIcon } from '../../assets/images/common/icons/lock-icon.svg'

const LockError = ({ titleText, children, linkAttributes, className }) => {
  const { linkMessage, ...filteredAttributes } = linkAttributes

  return (
    <div className={classnames('d-flex flex-column justify-content-center align-items-center py-3', classes.wrapper, { [className]: !!className })}>
      <div className={classes.error}>
        <LockIcon className={classes.icon} />
        <h1 className={classes.title}>{titleText}</h1>
        <div className={classes.message}>
          {children}
        </div>
        <ButtonLink className='w-fit-content' {...filteredAttributes}>
          {linkMessage}
        </ButtonLink>
      </div>
    </div>
  )
}

LockError.propTypes = {
  titleText: PropTypes.string.isRequired,
  children: PropTypes.node,
  linkAttributes: PropTypes.shape({
    linkMessage: PropTypes.string.isRequired,
    ...buttonLinkType,
  }).isRequired,
  className: PropTypes.string,
}

export default LockError
